export default "__VITE_ASSET__DUXxZ3RN__"